import { render } from "./CatalogActionModals.vue?vue&type=template&id=76c5c362&ts=true"
import script from "./CatalogActionModals.vue?vue&type=script&lang=ts"
export * from "./CatalogActionModals.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Data\\TCF\\ABBp_PIS\\6.12\\PisNextGenExtTrain-PisApp_6_12_0\\PisNextGenExtTrain\\PisNextGen\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__